// src/hooks/useUpdateSinisterProperty.ts
import { useState } from "react";
import { useToast } from "../../../shared/hooks";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";

export function useUpdateSinisterProperty(refetch: () => void, onClose: () => void) {
	const [isLoading, setIsLoading] = useState(false);
	const toastHandler = useToast();

	const update = async (id: string, data: { busyProperty: string }) => {
		setIsLoading(true);
		try {
			await SinisterService.updatePropertySinister(id, data);
			await refetch();
			toastHandler.present({
				type: "success",
				messageOrContent: "Situação do imóvel atualizada com sucesso!",
			});
			onClose();
		} catch {
			toastHandler.present({
				type: "error",
				messageOrContent: "Erro ao atualizar status do imóvel",
			});
		} finally {
			setIsLoading(false);
		}
	};

	return { update, isLoading };
}
